import { Divider, Paper, Stack, Typography } from "@mui/material"
import { Trans } from "react-i18next";
import AssignmentsTable from "./AssignmentsTable";


const Assignments = (): JSX.Element => {
    return (
        <Paper elevation={2} sx={{ px: 2, py: 2}}>
            <Stack direction={'column'} spacing={1}>
                <Typography variant={'h4'}>
                    <Trans>Assignments</Trans>
                </Typography>
                <Divider />
                <AssignmentsTable />
            </Stack>
        </Paper>
    )
}

export default Assignments;